/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
/* tslint:disable:max-func-body-length */

import { Button, Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as Msdyn365 from '@msdyn365-commerce/core';
import * as React from 'react';
import DobbiesModal from './components/dobbies-modal';
import { IContentBlockViewProps } from './dobbies-marketing-content-block';

const ContentBlockView: React.FC<IContentBlockViewProps> = props => {
    const { contentBlockContainer, imageContainer, detailsContainer, title, text, image } = props;

    const [isPopupOpen, setIsPopupOpen] = React.useState(false);

    // Open popup by clicking on join now button

    // Render Popup title
    const _renderPopupTitle = () => {
        const { popUpHeading } = props.config;
        return (
            <Node className='popup-header' tag='div'>
                <Node role='button' onClick={_closePopup} className='newsletter-popup-cross' />
                {popUpHeading && (
                    <Msdyn365.Text {...popUpHeading} tag={popUpHeading.tag} className={'popup__heading'} text={popUpHeading.text} />
                )}
            </Node>
        );
    };

    // Render popup footer
    const _renderPopupFooter = () => {
        return <></>;
    };
    // Render popup body to show input fields
    const _renderPopupBody = () => {
        return (
            <div>
                <p className='dobbies-club-modal-text'>Start using your benefits as soon as you sign up, all for just £12 a year.</p>
                <div className='dobbies-club-modal-btns'>
                    <Button onClick={redirectToClubPlus} className='join-club-btn msc-btn close-popup'>
                        Join Club Plus
                    </Button>

                    <Button onClick={redirectToClubPlusTrial} className='join-trail-btn msc-btn close-popup'>
                        Join Club Plus Free Trial
                    </Button>
                </div>
            </div>
        );
    };

    const redirectToClubPlus = () => {
        setIsPopupOpen(false);
        window.location.assign(props.config.clubPlusLoyaltyURL!);
    };

    const _closePopup = () => {
        setIsPopupOpen(false);
    };

    const redirectToClubPlusTrial = () => {
        setIsPopupOpen(false);
        window.location.assign(props.config.clubPlusTrialLoyaltyURL!);
    };

    // const getTier = (props: IContentBlockViewProps) => {
    //     const loyaltyGroup = props.data.loyaltyCard.result?.LoyaltyGroups && props.data.loyaltyCard.result?.LoyaltyGroups[0];
    //     // highestLoyaltCardTier
    //     const highestActiveLoyaltyCardTier = loyaltyGroup && loyaltyGroup.HighestActiveLoyaltyCardTier;
    //     const loyaltyCardTiers = loyaltyGroup && loyaltyGroup.LoyaltyCardTiers;
    //     // Get TierId based on the active cardTier
    //     if (loyaltyCardTiers && loyaltyCardTiers?.length > 0) {
    //         for (const [_, loyaltyCardTier] of loyaltyCardTiers.entries()) {
    //             if (loyaltyCardTier.RecordId === highestActiveLoyaltyCardTier) {
    //                 return loyaltyCardTier;
    //             }
    //         }
    //     }
    //     return;
    // };

    // const handleClickSignup = () => {
    //     const tier = getTier(props);
    //     if (tier && tier.TierId !== 'Club') {
    //         // CHECK WHAT THE NUMBER OF DAYS SETUP IN CMS IS
    //         // CHECK THE LOYALTY EXPIRY DATE
    //         // MATCH THE TWO DATES, if value less than or equals to 0 from cms, then allow it, otherwise, go back to club plus
    //         const today = new Date();
    //         const validTill = new Date(props.data.loyaltyCard.result?.LoyaltyGroups![0].LoyaltyCardTiers![0].ValidFrom!);
    //         const expiryDate = new Date(today);
    //         const validNumberOfDays: number = props.app.config.CheckValidityForTheNumberOfDays;
    //         expiryDate.setDate(expiryDate.getDate() + validNumberOfDays);

    //         // To calculate the time difference of two dates
    //         const differenceInTime = expiryDate.getTime() - validTill.getTime();

    //         // To calculate the no. of days between two dates
    //         const differenceInDays = differenceInTime / (1000 * 3600 * 24);

    //         if (differenceInDays <= 0) {
    //             setIsPopupOpen(true);
    //         } else {
    //             // If the user is a club plus trial member, redirect them to dobbies club plus signup
    //             const highestActiveLoyaltyCardTier = props.data.loyaltyCard.result?.LoyaltyGroups![0].HighestActiveLoyaltyCardTier;

    //             const activatedTier = props.data.loyaltyCard.result?.LoyaltyGroups![0].LoyaltyCardTiers!.find(
    //                 card => card.RecordId === highestActiveLoyaltyCardTier
    //             );

    //             if (activatedTier && activatedTier.TierId === 'Club Plus Free Trial') {
    //                 window.location.assign(props.config.clubPlusLoyaltyURL!);
    //             } else {
    //                 setIsPopupOpen(true);
    //             }
    //         }
    //     } else {
    //         setIsPopupOpen(true);
    //     }
    // };
    const isLoyaltyinProgress = props.context.request.cookies.get(props.context.request.user.customerAccountNumber!);
    return (
        <Module {...contentBlockContainer}>
            <Node {...imageContainer}>{image}</Node>
            <Node {...detailsContainer}>
                {title}
                {text}

                <div className='ms-content-block__cta st-bgwhite'>
                    {/* href="https://dobbies-ecommerce.commerce.dynamics.com/dobbies/loyalty-join?tier=club-plus" */}
                    {isLoyaltyinProgress.value === 'true' ? (
                        props.config.statusMessage
                    ) : (
                        <a
                            href={props.config.clubPlusLoyaltyURL}
                            className='msc-cta__primary btn__clubmarketing'
                            role='button'
                            title='Sign up'
                            aria-label='sign-up'
                            data-exp-event-id='Dobbies-club-marketing.Content block.Sign up.click'
                        >
                            <div>Sign up</div>
                        </a>
                    )}
                </div>

                {/* {_renderPopUp()} */}

                {isPopupOpen && (
                    <DobbiesModal
                        isOpen={isPopupOpen}
                        modalTitle={_renderPopupTitle()}
                        modalBodyElement={_renderPopupBody()}
                        modalFooter={_renderPopupFooter()}
                        className='ms-dobbies-newsletter-popup modal'
                    />
                )}
            </Node>
        </Module>
    );
};

export default ContentBlockView;
